// Module
var code = "<cloudwatch-annotation-query-editor datasource=\"ctrl.datasource\" on-change=\"ctrl.onChange\" query=\"ctrl.annotation\"></cloudwatch-annotation-query-editor>\n";
// Exports
var _module_exports =code;;
var path = 'public/app/plugins/datasource/cloudwatch/partials/annotations.editor.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;